// Returns angle in positive whole integer value between 0 – 360º
const sanitizeAngle = (angle?: number) => {
  if (!angle) return 0;

  return angle < 0 ? Math.round(360 + angle) : Math.round(angle);
};

export default sanitizeAngle;
